import { Component, OnInit, Input } from '@angular/core';
import { ModalController, RadioGroupChangeEventDetail } from '@ionic/angular';
import { PickupLocation } from 'src/app/pages/waktu-pengambilan/waktu-pengambilan.page';

@Component({
  selector: 'app-modal-select-pickup-location',
  templateUrl: './modal-select-pickup-location.component.html',
  styleUrls: ['./modal-select-pickup-location.component.scss'],
})
export class ModalSelectPickupLocationComponent implements OnInit {
  @Input() selectedPickupLocation: PickupLocation;
  @Input() pickupLocations: PickupLocation[];
  currentPickupLocation: PickupLocation;

  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  radioGroupChange(event: Event) {
    const customEvent = event as CustomEvent<RadioGroupChangeEventDetail>;
    const id = customEvent.detail.value;
    this.currentPickupLocation = this.pickupLocations.find(loc => loc.id === id);
  }

  confirm() {
    this.modalController.dismiss({ selectedPickupLocation: this.currentPickupLocation }, 'confirm');
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }
}
